// extracted by css-extract-rspack-plugin
export default {"cls1":"TabbedPreviewList-cls1_Dt-","cls2":"TabbedPreviewList-cls2_B5o TabbedPreviewList-cls1_Dt-"};